var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoutIcon = function SvgLogoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M11.493 2.5C13.975 2.5 16 4.49 16 6.94v4.79H9.895a.77.77 0 0 0-.783.77c0 .42.346.77.783.77H16v4.78c0 2.45-2.025 4.45-4.528 4.45H6.517C4.025 22.5 2 20.51 2 18.06V6.95C2 4.49 4.035 2.5 6.528 2.5zm7.047 6.55c.3-.31.79-.31 1.09-.01l2.92 2.91a.764.764 0 0 1 0 1.09l-2.92 2.91c-.15.15-.35.23-.54.23a.773.773 0 0 1-.55-1.32l1.6-1.59H16v-1.54h4.14l-1.6-1.59c-.3-.3-.3-.79 0-1.09"
  })));
};
export default SvgLogoutIcon;